import React from 'react';

const LoadingSkeleton = ({ type = 'product', count = 1 }) => {
  const skeletons = Array.from({ length: count }, (_, index) => {
    switch (type) {
      case 'product':
        return (
          <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden animate-pulse">
            <div className="w-full h-48 bg-gray-300"></div>
            <div className="p-4 space-y-3">
              <div className="h-4 bg-gray-300 rounded w-3/4"></div>
              <div className="h-3 bg-gray-300 rounded w-1/2"></div>
              <div className="flex items-center justify-between">
                <div className="h-6 bg-gray-300 rounded w-1/4"></div>
                <div className="h-8 bg-gray-300 rounded w-1/3"></div>
              </div>
            </div>
          </div>
        );

      case 'search':
        return (
          <div key={index} className="flex items-center gap-3 p-2 animate-pulse">
            <div className="w-12 h-12 bg-gray-300 rounded-lg"></div>
            <div className="flex-1 space-y-2">
              <div className="h-4 bg-gray-300 rounded w-3/4"></div>
              <div className="h-3 bg-gray-300 rounded w-1/2"></div>
            </div>
          </div>
        );

      case 'cart':
        return (
          <div key={index} className="flex gap-4 p-4 bg-gray-50 rounded-lg animate-pulse">
            <div className="w-16 h-16 bg-gray-300 rounded-lg"></div>
            <div className="flex-1 space-y-2">
              <div className="h-4 bg-gray-300 rounded w-3/4"></div>
              <div className="h-3 bg-gray-300 rounded w-1/2"></div>
              <div className="h-5 bg-gray-300 rounded w-1/4"></div>
            </div>
          </div>
        );

      case 'category':
        return (
          <div key={index} className="animate-pulse">
            <div className="w-full h-32 bg-gray-300 rounded-lg mb-3"></div>
            <div className="h-4 bg-gray-300 rounded w-2/3 mx-auto"></div>
          </div>
        );

      case 'hero':
        return (
          <div key={index} className="animate-pulse">
            <div className="w-full h-96 bg-gray-300 rounded-lg mb-6"></div>
            <div className="space-y-4 max-w-2xl mx-auto text-center">
              <div className="h-8 bg-gray-300 rounded w-3/4 mx-auto"></div>
              <div className="h-4 bg-gray-300 rounded w-full"></div>
              <div className="h-4 bg-gray-300 rounded w-2/3 mx-auto"></div>
              <div className="h-12 bg-gray-300 rounded w-1/3 mx-auto"></div>
            </div>
          </div>
        );

      default:
        return (
          <div key={index} className="animate-pulse">
            <div className="h-4 bg-gray-300 rounded w-full mb-2"></div>
            <div className="h-4 bg-gray-300 rounded w-3/4"></div>
          </div>
        );
    }
  });

  return <>{skeletons}</>;
};

export default LoadingSkeleton;
